var displayInterMasonrylayout = (function () {

  function init() {

    var showMoreBtn = document.querySelector(".btn-stories-load-more");

    //Pagination show more button
    if (showMoreBtn) {
      showMoreBtn.addEventListener(
        "click",
        function (evt) {
          evt.preventDefault();

          var that = this,
            dataAjax = {
              perpage: that.dataset.perpage,
              offset: that.dataset.offset
            };

          testimonialDataAjax(dataAjax);
        },
        false
      );
    }
  }

  function testimonialDataAjax(dataAjax) {
    var pageBtn = document.querySelector(".btn-stories-load-more"),
    listPostElm = document.querySelector(".d-p-l-masonry-layout");

    pageBtn.setAttribute("disabled", "disabled");
    pageBtn.innerHTML = pageBtn.dataset.btndisabled;

    bsLib.ajax(
      "POST",
      bsLib.railsHost() + "/wp-admin/admin-ajax.php",
      bsLib.extend({
        action: "bstack_testimonial_card_data",
        security: ajax_initialize_script.ajax_nonce
      },
        dataAjax
      ),
      true, //async	
      {
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
      }, //request header	
      function (data) {
        if (data.readyState === 4) {
          var dataRequest = bsLib.JSONParse(data.response),
            storiesRow = document.querySelector(".d-p-l-masonry-layout");

          if (dataRequest.status) {
            if (dataAjax.offset > 0) {
              storiesRow.insertAdjacentHTML('beforeend', dataRequest.html);
            } else {
              storiesRow.innerHTML = dataRequest.html;
            }

            pageBtn.dataset.offset = dataRequest.offset;

            if ((dataRequest.offset * dataAjax.perpage) < dataRequest.filtered) {
              pageBtn.classList.add("hide");
            }

            pageBtn.removeAttribute("disabled");
            pageBtn.innerHTML = pageBtn.dataset.btntext;

            lazyLoading.show();
          }
        }
      }, //success	
      function () { } //error object	
    );
  }

  init();
})();